<div class="row">
  <div class="col-lg-12">
    <h1>Error</h1>
    <div class="alert alert-danger">
      You're not authorized to perform this action
    </div>
  </div>
</div>

